import { FC, useRef } from "react";
import * as _ from "lodash";
import * as Sentry from "@sentry/react";

import { Col, Row, Skeleton } from "@ctra/components";
import { classname, Epoch, TS } from "@ctra/utils";

import { Chart, ChartFilterContext, ChartAPIContext } from "@chart";
import { useInsight, InsightValidation, VulcanV2Insight } from "@insights";

import baseStyles from "../InsightBody/InsightBody.module.less";
import styles from "./VulcanV2InsightBody.module.less";
import moment from "moment";

/**
 * Insight body for KPI insights
 * @constructor
 */
export const VulcanV2InsightBody: FC = () => {
  const {
    getMetadata,
    getChartConfig,
    insight: { startEpoch, endEpoch, farm },
    meta: { isLoading },
    convertAnomalyValue
  } = useInsight<VulcanV2Insight>();

  const config = getChartConfig();
  const { variantId: id, subject, points } = getMetadata();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>();

  return (
    <Skeleton active loading={isLoading}>
      <Row className={classname(baseStyles.Row, baseStyles.Padded)}>
        <Col flex={1}>
          <InsightValidation />
        </Col>
      </Row>
      <Sentry.ErrorBoundary fallback={<>{null}</>}>
        <Row className={classname(styles.ChartContainer, baseStyles.Row, baseStyles.PaddedChart)}>
          <Col flex={1}>
            <ChartFilterContext.Provider
              series={{ [id]: [_.trim(subject)] }}
              timePeriod={{
                startDate: TS.serialize(Epoch.asMoment(startEpoch).subtract(1, "month")) as string,
                endDate: TS.serialize(
                  moment.min(Epoch.asMoment(endEpoch).add(1, "month"), moment().startOf("day"))
                ) as string
              }}
            >
              <ChartAPIContext.Provider metricVariantID={id} farmID={farm}>
                <Chart
                  ref={ref}
                  viewOptions={{ showToolbar: true, zoomEnabled: false }}
                  config={{
                    ...config,
                    annotations: _.map(points, ({ x, y }) => ({
                      type: "dataMarker",
                      position: [x, convertAnomalyValue(y)],
                      point: {
                        style: {
                          fill: "#CF1322",
                          stroke: "#CF1322"
                        }
                      },
                      autoAdjust: false
                    })),
                    onReady: (plot) => {
                      ref.current = plot;
                    }
                  }}
                />
              </ChartAPIContext.Provider>
            </ChartFilterContext.Provider>
          </Col>
        </Row>
      </Sentry.ErrorBoundary>
    </Skeleton>
  );
};
